export enum TableCellData_VerticalAlignment {
  /** TOP - Top alignment */
  TOP = 'TOP',
  /** MIDDLE - Middle alignment */
  MIDDLE = 'MIDDLE',
  /** BOTTOM - Bottom alignment */
  BOTTOM = 'BOTTOM',
  UNRECOGNIZED = 'UNRECOGNIZED',
}